/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespAppliedFilters_viewer$ref = any;
type SbSharedRefineMenuFilters_viewer$ref = any;
export type SbRespRefineMenu_viewer$ref = any;
export type SbRespRefineMenu_viewer = {
    readonly isDeliveryOptionsDisabled: boolean | null;
    readonly isSbSharedRefineMenuDisplayPrefsSelectEnabled: boolean | null;
    readonly " $fragmentRefs": SbRespAppliedFilters_viewer$ref & SbSharedRefineMenuFilters_viewer$ref;
    readonly " $refType": SbRespRefineMenu_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenu_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isDeliveryOptionsDisabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "DISABLE_SB_DELIVERY_OPTION_FILTERS"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"DISABLE_SB_DELIVERY_OPTION_FILTERS\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isSbSharedRefineMenuDisplayPrefsSelectEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '39f209dc12eb170b2cfa899dbe128ec4';
export default node;
